__turbopack_context__.v({
  "control": "YouTube-module__99hYHq__control",
  "controls": "YouTube-module__99hYHq__controls",
  "docked": "YouTube-module__99hYHq__docked",
  "expanded": "YouTube-module__99hYHq__expanded",
  "help": "YouTube-module__99hYHq__help",
  "mini": "YouTube-module__99hYHq__mini",
  "panel": "YouTube-module__99hYHq__panel",
  "video": "YouTube-module__99hYHq__video",
});
